export var daysInWeek = 7;
export var daysInYear = 365.2425;
export var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1e3;
export var millisecondsInMinute = 6e4;
export var millisecondsInHour = 36e5;
export var millisecondsInSecond = 1e3;
export var minTime = -maxTime;
export var minutesInHour = 60;
export var monthsInQuarter = 3;
export var monthsInYear = 12;
export var quartersInYear = 4;
export var secondsInHour = 3600;
export var secondsInMinute = 60;
export var secondsInDay = secondsInHour * 24;
export var secondsInWeek = secondsInDay * 7;
export var secondsInYear = secondsInDay * daysInYear;
export var secondsInMonth = secondsInYear / 12;
export var secondsInQuarter = secondsInMonth * 3;
